(function () {
	'use strict';

	// TODO: Seems it's obsolete. Get rid of it.

	angular.module('mx.components').component('mxGridEditForm', {
		bindings: {
			row: '<',
		},
		controller: MxGridEditFormCtrl,
		controllerAs: 'vm',
		templateUrl: 'mx-grid/mx-grid-edit-form.html',
	});

	MxGridEditFormCtrl.$inject = ['$scope', '$timeout', '$injector', '$element', '$rootScope', '$compile'];

	function MxGridEditFormCtrl($scope, $timeout, $injector, $element, $rootScope, $compile) {
		var vm = this;

		vm.$onInit = function () {
			vm.save = save;
			vm.cancel = cancel;
			vm.formFields = vm.row.grid.appScope.formFields;

			vm.localScope = vm.formFields ? {} : $rootScope.$new(false, $scope);
			vm.localScope.entity = angular.copy(vm.row.entity);

			vm.localScope.click = function () {};

			if (!vm.formFields) {
				if (vm.row.grid.appScope.template) {
					vm.template = vm.row.grid.appScope.template.replace(/&apos;/g, "'");
				}
				vm.localScope.row = vm.row;
				//var div = $element.find('.mx-grid-edit-form-inner---content');
				var div = angular.element($element[0].querySelector('.mx-grid-edit-form-inner---content'));
				var el = $compile(vm.template)(vm.localScope);
				div.append(el);
			}
		};

		return vm;

		function save() {
			angular.extend(vm.row.entity, vm.localScope.entity);
			vm.row.grid.appScope.closeInlineForm(true);
		}

		function cancel() {
			vm.row.grid.appScope.closeInlineForm(false);
		}
	}
})();
